import { Autocomplete, Box, FormControl, FormHelperText, InputLabel, MenuItem, Select as MuiSelect, SelectProps as MuiSelectProps, TextField, TextFieldProps } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'

type SelectMultipleProps = MuiSelectProps & TextFieldProps & {
  name: string,
  label?: string,
  options: {
    value: string | number,
    label?: string
  }[]
  shouldUnregister?: boolean,
  searchable?: boolean,
  startAdornment?: React.ReactNode
}

export const SelectMultiple: React.FC<SelectMultipleProps> = ({ name, label, shouldUnregister = false, searchable = false, options, ...rest }) => {
  const { control } = useFormContext()

  return (
    <FormControl fullWidth>
      <Controller
        name={name}
        control={control}
        shouldUnregister={shouldUnregister}
        defaultValue={[]}
        render={({ field, fieldState: { error } }) => (
          <>
            {!searchable ? (
              <>
                <InputLabel id={field.name}>{label}</InputLabel>
                <MuiSelect error={Boolean(error?.message)} label={label} {...rest} {...field} onChange={e => field.onChange([...field.value, e.target.value])}>
                  <MenuItem value=''>Selecione</MenuItem>
                  {options.map((option, index) => {
                    return (
                      <MenuItem
                        value={option.value}
                        key={`select-option-${option.value}-${index}`}
                      >
                        <Box
                          sx={{
                            gap: 1,
                            display: 'flex',
                            alignItems: 'center'
                          }}
                        >
                          {option.label}
                        </Box>
                      </MenuItem>
                    )
                  })}
                </MuiSelect>
                {error && <FormHelperText sx={{ color: 'error.main' }}>{error.message}</FormHelperText>}
              </>
            ) : (
              <>
                <Autocomplete
                  disableClearable={true}
                  autoHighlight
                  options={options}
                  onChange={(ev, value) => field.onChange([...field.value, value?.value])}
                  renderInput={(params) => <TextField {...params} fullWidth variant='outlined'  {...rest}  InputLabelProps={{ ...params.InputLabelProps }}  InputProps={{ ...params.InputProps }} label={label} />}
                  renderOption={(props, option) => <Box component='li' {...props} key={option.value}>{option.label}</Box>}
                />
              </>
            )}
          </>
        )}
      />
    </FormControl>
  )
}

